import React from 'react';
import BrowserCompatibilityNotification from './Common/BrowserCompatibilityNotification';

import { AccountContextProvider } from './Data/accountContext';
import RegistrationRoute from './RegistrationRoute';

export default function AppRegistration(props) {
  const { form, accountId } = props.params.match.params;

  return (
    <div className="register-w">
      <BrowserCompatibilityNotification />
      <AccountContextProvider>
        <RegistrationRoute
          path="/app/registration/:form/:accountId?"
          form={form}
          redirectPath={`/app/registration/account/${accountId || ''}`}
        />
      </AccountContextProvider>
    </div>
  );
}
